module.exports = __webpack_public_path__ + "img/35000元年.52acdbc5.png";